
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinokhladelhi() {



    const cardData =
    {
        keyword: '  Corporate Cab Services in Okhla Delhi  ',
        heading: 'etravo :   Corporate Cab Services in Okhla Delhi',



"headingDescription": "eTravo offers reliable Corporate Cab Services in Okhla Delhi, designed for industrial units, corporate offices, and professionals who require seamless transportation for employee commuting, client meetings, airport transfers, and executive travel. With GPS-enabled vehicles, experienced chauffeurs, and flexible monthly plans, eTravo ensures safe, punctual, and comfortable corporate mobility across Okhla and nearby business hubs in Delhi NCR.",

"top": "Top Corporate Cab Service Areas in Okhla Delhi with eTravo",

"topPlaces": [
  {
    "title": "Okhla Phase I Industrial Area",
    "description": "A major industrial and commercial zone with factories and offices requiring daily employee pickup and drop services."
  },
  {
    "title": "Okhla Phase II Industrial Area",
    "description": "Home to manufacturing units and corporate offices needing structured workforce transportation and shift-based cab services."
  },
  {
    "title": "Okhla Phase III",
    "description": "A developing industrial and business area with growing demand for corporate travel and employee transport solutions."
  },
  {
    "title": "Jasola District Centre",
    "description": "A nearby commercial hub with corporate offices, banks, and business centers requiring executive travel and daily commuting services."
  },
  {
    "title": "Nehru Place",
    "description": "A major IT and business district close to Okhla, generating high demand for corporate cab services."
  },
  {
    "title": "Sarita Vihar",
    "description": "A residential and commercial locality supporting workforce commuting to Okhla industrial areas."
  },
  {
    "title": "Kalkaji",
    "description": "A well-connected area near Okhla with offices and residential zones requiring reliable employee transportation."
  },
  {
    "title": "New Friends Colony",
    "description": "A premium residential area with corporate professionals needing daily pickup and drop services."
  },
  {
    "title": "Tughlakabad Industrial Area",
    "description": "A nearby industrial hub with manufacturing and logistics units requiring workforce mobility solutions."
  },
  {
    "title": "Okhla to IGI Airport Route",
    "description": "A key corporate travel corridor used for airport transfers, executive travel, and business connectivity."
  }
],


"services": [
{
"name": "Corporate Cab Okhla Delhi",
"description": "eTravo offers reliable corporate cab services in Okhla Delhi designed for smooth and professional business travel. Our service ensures punctual pickups, comfortable rides, and experienced chauffeurs for daily office commuting and executive travel."
},
{
"name": "Taxi Service Okhla Delhi",
"description": "Our taxi services in Okhla Delhi provide quick and dependable transportation for professionals and employees. eTravo ensures clean vehicles, timely service, and a hassle-free travel experience across industrial and office areas."
},
{
"name": "Company Cab Okhla",
"description": "eTravo provides company cab services in Okhla tailored for corporate needs. From employee transport to executive travel, our service ensures reliability, safety, and smooth operations."
},
{
"name": "Office Transport Okhla Delhi",
"description": "Simplify employee commuting with eTravo’s office transport services in Okhla Delhi. We offer structured and efficient transportation solutions for daily travel across business hubs."
},
{
"name": "Employee Cab Okhla",
"description": "Our employee cab services in Okhla are designed for safe and punctual commuting. eTravo ensures well-coordinated pickup and drop services for smooth daily travel."
},
{
"name": "Corporate Travel Okhla Delhi",
"description": "eTravo offers corporate travel services in Okhla Delhi for both local and outstation business needs. Our service ensures reliable and comfortable journeys for executives and teams."
},
{
"name": "Business Cab Okhla",
"description": "eTravo’s business cab services in Okhla are ideal for meetings, client visits, and corporate activities. Our service focuses on punctuality and professional travel experiences."
},
{
"name": "Staff Transport Okhla Delhi",
"description": "eTravo provides dependable staff transport services in Okhla Delhi for daily employee commuting. Our service ensures timely pickups, safe rides, and efficient travel coordination."
},
{
"name": "Corporate Taxi Okhla",
"description": "Our corporate taxi services in Okhla offer flexible and reliable transportation for businesses. eTravo ensures smooth travel for employees, executives, and corporate clients."
},
{
"name": "Company Taxi Okhla Delhi",
"description": "eTravo’s company taxi services in Okhla Delhi provide convenient travel solutions for corporate requirements. Our taxis are ideal for daily operations and client handling."
},
{
"name": "Corporate Pickup Drop Okhla",
"description": "eTravo offers corporate pickup and drop services in Okhla for efficient employee commuting. Our service ensures punctual scheduling and comfortable travel experiences."
},
{
"name": "Office Cab Booking Okhla",
"description": "Book office cabs in Okhla easily with eTravo. Our reliable service ensures timely pickups, comfortable rides, and hassle-free travel for corporate teams."
},
{
"name": "Business Travel Cab Okhla",
"description": "Our business travel cab services in Okhla are designed for professionals traveling for meetings and corporate tasks. eTravo ensures smooth and efficient journeys."
},
{
"name": "Corporate Commute Okhla Delhi",
"description": "eTravo’s corporate commute services in Okhla Delhi provide structured and dependable employee transportation. Our service ensures smooth daily travel for corporate staff."
},
{
"name": "Professional Cab Service Okhla",
"description": "eTravo offers professional cab services in Okhla with trained drivers and well-maintained vehicles. Our service ensures safe, comfortable, and reliable travel for all business needs."
}
],
"tableData": [
["Corporate Cab Okhla Delhi", "Taxi Service Okhla Delhi"],
["Company Cab Okhla", "Office Transport Okhla Delhi"],
["Employee Cab Okhla", "Corporate Travel Okhla Delhi"],
["Business Cab Okhla", "Staff Transport Okhla Delhi"],
["Corporate Taxi Okhla", "Company Taxi Okhla Delhi"],
["Corporate Pickup Drop Okhla", "Office Cab Booking Okhla"],
["Business Travel Cab Okhla", "Corporate Commute Okhla Delhi"],
["Professional Cab Service Okhla", ""]
],




"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Cab Services in Okhla Delhi",
      "WhyChoosedescription": "eTravo offers dependable corporate cab services in Okhla Delhi, ensuring smooth and efficient transportation for employees, executives, and business clients across Okhla Industrial Area and nearby commercial zones."
    },
    {
      "WhyChooseheading": "Ideal for Okhla Industrial Area Businesses",
      "WhyChoosedescription": "Okhla Industrial Area is one of Delhi’s major business and manufacturing hubs, making structured corporate transportation essential for daily workforce mobility and operational efficiency. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Daily Employee Pickup and Drop Solutions",
      "WhyChoosedescription": "Corporate cab services provide organized daily pickup and drop with route optimization, ensuring employees reach offices on time and reducing commute challenges in busy Delhi traffic. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Wide Fleet for Corporate Travel Needs",
      "WhyChoosedescription": "We offer hatchbacks, sedans, SUVs, and executive vehicles suitable for employee transport, client meetings, and business travel requirements in and around Okhla."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Local Expertise",
      "WhyChoosedescription": "Our drivers are experienced and familiar with Okhla, Jamia Nagar, and surrounding areas, ensuring safe, punctual, and efficient travel for corporate employees."
    },
    {
      "WhyChooseheading": "Flexible Monthly and Contract-Based Plans",
      "WhyChoosedescription": "Companies can choose from monthly corporate cab contracts, daily commute services, and customized plans tailored to workforce size and shift timings. :contentReference[oaicite:3]{index=3}"
    },
    {
      "WhyChooseheading": "Safe, Clean, and Well-Maintained Vehicles",
      "WhyChoosedescription": "All vehicles are regularly serviced and sanitized, ensuring safety, hygiene, and comfort for employees during daily travel."
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate Travel Needs",
      "WhyChoosedescription": "Our support team operates round the clock to manage bookings, schedule changes, and urgent travel requirements for uninterrupted business operations."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What are corporate cab services in Okhla Delhi?',
            answer: 'Corporate cab services in Okhla Delhi provide organized transportation for employees, executives, and clients including daily office commute and business travel.',
        },
        {
            question: 'Why are corporate cab services important in Okhla?',
            answer: 'Okhla is a major industrial and business hub, and reliable transportation ensures employees reach offices on time and improves productivity. :contentReference[oaicite:4]{index=4}',
        },
        {
            question: 'Do corporate cab services provide daily pickup and drop?',
            answer: 'Yes, services include structured daily pickup and drop with fixed routes and schedules for employees. :contentReference[oaicite:5]{index=5}',
        },
        {
            question: 'Are monthly corporate cab contracts available in Okhla?',
            answer: 'Yes, companies can opt for monthly and long-term contracts with dedicated vehicles and drivers. :contentReference[oaicite:6]{index=6}',
        },
        {
            question: 'What types of vehicles are available for corporate travel?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, and executive cars depending on employee and business requirements.',
        },
        {
            question: 'Are corporate cab services safe for employees?',
            answer: 'Yes, services include GPS tracking, verified drivers, and safety protocols to ensure secure travel.',
        },
        {
            question: 'Can corporate travel plans be customized?',
            answer: 'Yes, companies can customize routes, schedules, and rental plans based on their workforce needs.',
        },
        {
            question: 'Are corporate cab services available 24/7 in Okhla?',
            answer: 'Yes, most providers operate round the clock to support shift-based operations and business travel.',
        },
        {
            question: 'Do corporate cab services provide airport transfers?',
            answer: 'Yes, airport pickup and drop services are available for employees and corporate clients traveling from Okhla.',
        },
        {
            question: 'How can I book corporate cab services in Okhla Delhi?',
            answer: 'You can book through the service provider’s website or contact their support team for customized corporate travel solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Anil Verma',
        designation: 'Operations Manager, Manufacturing Company, Okhla',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has improved our employee transport in Okhla. Their punctual service and professional drivers ensure smooth daily operations.”',
    },
    {
        name: 'Ms. Pooja Sharma',
        designation: 'HR Manager, Corporate Firm, Delhi',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for workforce transportation in Okhla. Their flexible plans and reliable service make commuting easy for our employees.”',
    },
];




    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Okhla Delhi",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-okhla-delhi.jpg",
  "description": "Reliable corporate cab services in Okhla, Delhi by eTravo. Ideal for employee transport, office pickup and drop, business travel, corporate commute, and professional taxi solutions with safe and timely service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-in-okhla-delhi"
  }
};





    return (
        <div>


<Helmet>
  <title>Corporate Cab Services in Okhla Delhi | Office & Employee Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab services in Okhla, Delhi with eTravo for employee transport, office pickup and drop, business travel, and corporate commute solutions. Safe and reliable service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/148.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinokhladelhi;